import styled from "styled-components";
import Colors from "../../Constant/Colors";
import { STYLES } from "../../Constant/Theme";

export const Container = styled.div`
  /* height: 100%; */
  height: calc(100% - 30px);
  width: 25%;
  min-width: 140px;
  position: absolute;
  right: 10px;
  top: 20px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 3px 5px 5px 5px #6662;
  box-sizing: border-box;
  padding: 10px;
  overflow: hidden;
  @media only screen and (max-width: 600px) {
    display: none;
    /* Styles for screens 600px and larger */
  }
`;

export const FolderList = styled.div`
  height: 70%;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  margin-top: 10px;
`;

export const EachFolder = styled.div`
  border-bottom: 1px solid #6662;
  height: ${(props) => (props.toggle ? null : "35px")};
  overflow: hidden;
  box-sizing: border-box;
`;
export const EachFolderHeading = styled.div`
  ${STYLES.spaceBetween};
  box-sizing: border-box;
  padding: 10px 0px;
  cursor: pointer;
`;

export const EachCourse = styled.div`
  width: 90%;
  height: ${(props) => (props.toggle ? null : "25px")};
  overflow: hidden;
  box-sizing: border-box;
  /* style={{ height: 30, overflow: "hidden", width: "90%" }} */
`;
export const EachCourseHeading = styled.div`
  ${STYLES.spaceBetween};
  /* padding: 5px 0px; */
  cursor: pointer;
`;

export const FlexEndDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;
